module.exports = __webpack_public_path__ + "static/media/facebook.b6902068.svg";